import styled from '@emotion/styled';

import ReCaptchaContainer from '../../../../../components/ReCaptchaContainer';

export const CreateAccountConfirmationRecaptchaContainer = styled(ReCaptchaContainer)`
  .grecaptcha-badge {
    display: none;
  }
`;
